import { useCallback } from "react"

interface FocalPointPickerProps {
  imageUrl: string
  focalPointX: number
  focalPointY: number
  onChange: (x: number, y: number) => void
}

export function FocalPointPicker({
  imageUrl,
  focalPointX,
  focalPointY,
  onChange,
}: FocalPointPickerProps) {
  const handleClick = useCallback(
    (e: React.MouseEvent<HTMLImageElement>) => {
      const rect = e.currentTarget.getBoundingClientRect()
      const x = Math.round(((e.clientX - rect.left) / rect.width) * 100)
      const y = Math.round(((e.clientY - rect.top) / rect.height) * 100)
      onChange(Math.max(0, Math.min(100, x)), Math.max(0, Math.min(100, y)))
    },
    [onChange],
  )

  return (
    <div className="space-y-2">
      <div className="relative inline-block cursor-crosshair">
        <img
          src={imageUrl}
          alt="Set focal point"
          className="max-h-[300px] rounded"
          onClick={handleClick}
          draggable={false}
        />
        <div
          className="pointer-events-none absolute h-6 w-6 -translate-x-1/2 -translate-y-1/2"
          style={{ left: `${focalPointX}%`, top: `${focalPointY}%` }}
        >
          <div className="absolute inset-0 rounded-full border-2 border-white shadow-md" />
          <div className="absolute top-1/2 left-1/2 h-1.5 w-1.5 -translate-x-1/2 -translate-y-1/2 rounded-full bg-white shadow" />
        </div>
      </div>
      <div className="flex items-center gap-3">
        <span className="text-hpi-med-gray text-xs">
          Focal point: {focalPointX}%, {focalPointY}%
        </span>
        {(focalPointX !== 50 || focalPointY !== 50) && (
          <button
            type="button"
            onClick={() => onChange(50, 50)}
            className="text-hpi-active-blue text-xs hover:underline"
          >
            Reset to Center
          </button>
        )}
      </div>
    </div>
  )
}
